import { MatPaginatorIntl } from '@angular/material/paginator';

const rangeLabel = (page: number, pageSize: number, length: number) => {
    if (length == 0 || pageSize == 0) { return `Página 0 de 0`; }

    length = Math.max(length, 0);

    const totalPages = Math.max(Math.ceil(length / pageSize), 1);
    const currentPage = Math.min(page + 1, totalPages);

    return `Página ${currentPage} de ${totalPages}`;
}


export function getPtBrPaginatorIntl() {
    const paginatorIntl = new MatPaginatorIntl();

    paginatorIntl.itemsPerPageLabel = 'Itens por página:';
    paginatorIntl.nextPageLabel = 'Próxima página';
    paginatorIntl.previousPageLabel = 'Página anterior';
    paginatorIntl.getRangeLabel = rangeLabel;

    return paginatorIntl;
}